var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "vNotification" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.shown,
            expression: "shown",
          },
        ],
        staticClass: "vNotificationWrapper",
        style: _vm.zIndex,
        on: {
          click: function ($event) {
            return _vm.handleOverlayClicked($event)
          },
        },
      },
      [_c("div", { class: _vm.type })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }